export var PaymentSectionText;
(function (PaymentSectionText) {
    PaymentSectionText["DEFAULT_TITLE"] = "Payment";
    PaymentSectionText["SELECT_CARD"] = "Select a card";
    PaymentSectionText["ADD_PAYMENT_METHOD"] = "Add payment method";
    PaymentSectionText["APPLY_COUPON"] = "Apply coupon";
    PaymentSectionText["APPLY_GIFTCARD"] = "Apply gift card";
    PaymentSectionText["PAY_LATER"] = "Pay later";
})(PaymentSectionText || (PaymentSectionText = {}));
